import { render } from "./CoachView.vue?vue&type=template&id=581949f0&scoped=true"
import script from "./CoachView.vue?vue&type=script&lang=js"
export * from "./CoachView.vue?vue&type=script&lang=js"

import "./CoachView.vue?vue&type=style&index=0&id=581949f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581949f0"]])

export default __exports__